import React from "react";

function PreReadSuccessFromTimeTable({ setSubmitPopup, setShowPreRead }) {
    return (
        <div className="ContainerSubmitedSucess ">
            <div className="SubContainerSubmitedSucess">
                <div className="d-flex justify-content-center align-items-center">
                    <img src="/HwImg/sucessIcon.png" alt="" />
                </div>
                <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg1">
                    You Have successfully submitted the Pre Read
                </div>
                <div className="d-flex justify-content-center align-items-center mt-2 sucessMsg2">
                    Once teacher evaluates, you will be notified
                </div>
                <div className="d-flex justify-content-center align-items-center mt-3">
                    <button
                        className="okayBtnsucess"
                        onClick={() => {
                            setSubmitPopup(false)
                            setShowPreRead(false)
                        }}
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PreReadSuccessFromTimeTable;
